import { ReactElement, useEffect } from 'react';

import { ScreenName, TypewriterTracking } from '@breathelife/frontend-tracking';

export type StateProps = {
  login: () => void;
};

type LoginProps = StateProps;

function LoginView({ login }: LoginProps): ReactElement {
  useEffect(() => {
    TypewriterTracking.viewedScreen({ screenName: ScreenName.login, hashedId: null });
    login();
  }, [login]);

  return <div />;
}

export default LoginView;
